export const SOCIAL_CARBON_ISSUANCE_BASE =
  'https://registry.socialcarbon.org/issuance_details/';

/** URL pública da emissão no Social Carbon (mesmo destino do ID do ativo no modal). */
export function buildSocialCarbonIssuanceUrl(id) {
  if (id == null || String(id).trim() === '') return null;
  return `${SOCIAL_CARBON_ISSUANCE_BASE}${encodeURIComponent(String(id))}`;
}
